import { useState } from 'react';
import { ReactComponent as IconCancel } from '../../../../../images/icon-cancel.svg';
import { useMessages } from '../../../contexts/MessageContext';
import { ContextMenu, ContextMenuItem, IconLink, Tooltip } from 'cai-fusion';

const ChatEntryAction = ({index, alt, options, onClick, messageId, messagePairId, message, icon: ActionIcon}) => {
	const [menuShown, setMenuShown] = useState(false);
	const { regenerateMessage } = useMessages;

	// Catch for objects that are empty. They will have nothing in them.
	if (!options && !ActionIcon) return <></>;

	return (
		// if has options instead, override the click function and do things differently
		<Tooltip text={alt} key={index}>
			{options && options.length > 0
				? 	<ContextMenu
						className='m-icon-row__icon'
						rightAligned
						isHidden={!menuShown}
						onClick={() => setMenuShown(!menuShown)}
						onBlur={() => setMenuShown(false)}
					>
						{options.map((option, index) => (
							<ContextMenuItem 
								key={index}
								name={option?.text}
								disabled={option?.disabled}
								Icon={option.Icon}
								onClick={() => {
									if (option.actionFunction) {
										option.actionFunction(messageId, messagePairId, message, regenerateMessage)
									}
								}}
							/>
						))}
					</ContextMenu>
				:	<IconLink
						Icon={ActionIcon}
						className='m-icon-row__icon'
						onClick={() => {
							if (onClick) {
								onClick(messageId, messagePairId, message, regenerateMessage)
							}
						}}
					/>
			}
		</Tooltip>
	);
};

export default ChatEntryAction;